import React from 'react';
import { ScrollReveal } from './shared';

const PropositionSection = () => {
  return (
    <section id="capabilities" className="section-spacing bg-white" data-testid="proposition-section">
      <div className="container-luxury">
        <ScrollReveal>
          <div className="max-w-3xl mx-auto text-center mb-16">
            <p className="overline mb-4">Our Capabilities</p>
            <h2 className="heading-section text-4xl sm:text-5xl text-[#0B1A2B] mb-6" data-testid="proposition-headline">
              De-Risking Decisions. Accelerating Growth.
            </h2>
            <p className="body-large">
              APIG helps leaders make high-stakes decisions with greater clarity and confidence. We uncover where the opportunity is, define how to win, and activate the leadership, partnerships, and resources needed to execute.
            </p>
          </div>
        </ScrollReveal>

        <div className="grid md:grid-cols-3 gap-8">
          {[
            {
              number: '01',
              title: 'Predictive Intelligence',
              description: 'We help clients determine where the real opportunity is, what customers and markets are most likely to respond to, and which risks could derail growth before significant capital or organizational energy is deployed.',
              proof: 'In one wealth management engagement, behavioral analytics reduced policy lapse rates by 8%.',
            },
            {
              number: '02',
              title: 'Strategic Positioning',
              description: 'We translate evidence into clearer choices: where to play, how to win, what to say, and which roadmap creates the strongest path to growth.',
              proof: 'In a leading medical device engagement, this approach helped retain 85% brand loyalty and improve reimbursement approval 3x.',
            },
            {
              number: '03',
              title: 'Growth Activation',
              description: 'We help leadership teams convert validated strategy into coordinated execution through operating priorities, leadership alignment, customer experience decisions, and growth-enabling partnerships.',
              proof: 'In a national auto service engagement, customer analytics contributed to $100M in revenue growth.',
            },
          ].map((cap, index) => (
            <ScrollReveal key={index} delay={index * 150}>
              <div className="p-8 lg:p-10 bg-white border border-[#E2E8F0] h-full transition-all duration-500 hover:shadow-lg hover:border-[#D97706]/30" data-testid={`capability-${index + 1}`}>
                <span className="text-[#D97706] font-serif text-2xl font-medium block mb-4">{cap.number}</span>
                <h3 className="font-serif text-xl lg:text-2xl text-[#0B1A2B] mb-4 leading-tight">{cap.title}</h3>
                <p className="text-[#334155] text-[0.9375rem] leading-relaxed mb-6">{cap.description}</p>
                <p className="text-[#64748B] text-sm italic border-t border-[#E2E8F0] pt-4">{cap.proof}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PropositionSection;
